var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var request = require('./request');

var Bmob = require('./bmob');

var Error = require('./error');

var utils = require('./utils');

var requestHap = "xxrequire('@system.request')xx";

var _require = require('./dataType'),
    isString = _require.isString,
    isArray = _require.isArray;

var list = [];

var file =
/*#__PURE__*/
function () {
  "use strict";

  function file(name, parma) {
    _classCallCheck(this, file);

    if (name && parma) {
      if (!isString(name)) {
        throw new Error(415);
      }

      list.push({
        name: name,
        route: "".concat(Bmob._config.parameters.FILES, "/").concat(name),
        data: parma
      });
    }
  }

  _createClass(file, [{
    key: "save",
    value: function save() {
      if (!list.length) {
        throw new Error(417);
      }

      var fileObj; // //获取当前应用类型

      var type = utils.getAppType(); // h5

      if (type === 'h5' || type === 'nodejs') {
        fileObj = new Promise(function (resolve, reject) {
          var data = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;
              request(item.route, 'post', item.data).then(function (url) {
                data.push(url);

                if (data.length === list.length) {
                  list = [];
                  resolve(data);
                  reject(data);
                }
              }).catch(function (err) {
                data.push(err);
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        });
      } else if (type === 'wx') {
        // 小程序
        fileObj = new Promise(function (resolve, reject) {
          if (undefined === Bmob.User) {
            Bmob = require('./bmob');
          }

          var sessionToken = 'bmob';
          var current = Bmob.User.current();

          if (current) {
            sessionToken = current.sessionToken;
          }

          var data = [];
          var key = {
            '_ApplicationId': Bmob._config.applicationId,
            '_RestKey': Bmob._config.applicationKey,
            '_SessionToken': sessionToken
          };
          var formData = Object.assign({
            '_ContentType': 'text/plain',
            'mime_type': 'text/plain',
            'category': 'wechatApp',
            '_ClientVersion': 'js3.6.1',
            '_InstallationId': 'bmob'
          }, key);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;
              wx.uploadFile({
                url: Bmob._config.host + item.route,
                // 仅为示例，非真实的接口地址
                filePath: item.data,
                name: 'file',
                header: {
                  'X-Bmob-SDK-Type': 'wechatApp'
                },
                formData: formData,
                success: function success(res) {
                  var url = JSON.parse(res.data);
                  data.push(url);

                  if (data.length === list.length) {
                    list = [];
                    resolve(data);
                    reject(data);
                  }
                },
                fail: function fail(err) {
                  data.push(err);
                }
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        });
      } else if (type === 'hap') {
        // 快应用功能
        fileObj = new Promise(function (resolve, reject) {
          if (undefined === Bmob.User) {
            Bmob = require('./bmob');
          }

          var current = Bmob.User.current();
          var data = [];
          var key = {
            '_ApplicationId': Bmob._config.applicationId,
            '_RestKey': Bmob._config.applicationKey,
            '_SessionToken': current.sessionToken
          };
          var formData = Object.assign({
            '_ContentType': 'text/plain',
            'mime_type': 'text/plain',
            'category': 'wechatApp',
            '_ClientVersion': 'js3.6.1',
            '_InstallationId': 'bmob'
          }, key);
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;
              requestHap.upload({
                url: Bmob._config.host + item.route,
                files: [{
                  uri: item.data,
                  name: 'file',
                  filename: item.name
                }],
                header: {
                  'X-Bmob-SDK-Type': 'wechatApp'
                },
                data: formData,
                success: function success(res) {
                  console.log('handling success' + data);
                  var url = res.data;
                  data.push(url);

                  if (data.length === list.length) {
                    list = [];
                    resolve(data);
                    reject(data);
                  }
                },
                fail: function fail(data, code) {
                  console.log("handling fail, code = ".concat(code));
                }
              });
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        });
      }

      return fileObj;
    }
  }, {
    key: "destroy",
    value: function destroy(parma) {
      if (isString(parma)) {
        return request("".concat(Bmob._config.parameters.FILES, "/upyun/").concat(parma.split('.com/')[1]), 'delete');
      } else if (isArray(parma)) {
        var data = [];
        parma.map(function (item) {
          data.push(item.split('.com/')[1]);
        });
        return request(Bmob._config.parameters.DELFILES, 'post', {
          'upyun': data
        });
      } else {
        throw new Error(415);
      }
    }
  }]);

  return file;
}();

module.exports = file;